export const ProfileFieldsCancel = {
  bindings: {
    hasError: '<',
    message: '<',
    form: '<',
    reasons: '<',
    subscription: '<',
    onSubmit: '&',
    onCancel: '&',
  },

  template: `
    <div class="profile-cancel">
      <div class="row">
        <div class="col-md-4">
          <h5>Cancel Subscription</h5>
          <p>Sorry to see you go.</p>
          <p>
            To cancel your subscription, please tell us why and then enter
            your password.
          </p>
        </div>
        <div class="col-md-8">
          <alert type="danger" ng-show="$ctrl.hasError">
            {{ $ctrl.message }}
          </alert>
          <form-group-row>
            <form-group-left>
              <form-label for="reason">
                Reason
              </form-label>
            </form-group-left>
            <form-group-right>
              <form-select
                form="$ctrl.form"
                name="reasonAnswer"
                required="true"
                errors="{ required: 'This is a required field.' }">
                <option value="">-- Select a reason --</option>
                <option
                  value="{{ reason }}"
                  ng-repeat="reason in $ctrl.reasons track by $index">
                  {{ reason }}
                </option>
              </form-select>
              <div class="mt-2"
                ng-show="$ctrl.form.data.reasonAnswer === 'Another reason'">
                <form-textarea
                  form="$ctrl.form"
                  name="reasonOther"
                  required="true"
                  placeholder="In a few words, please tell us why."
                  rows="4">
                </form-textarea>
              </div>
            </form-group-right>
          </form-group-row>
          <hr>
          <form-group-row>
            <form-group-left>
              <form-label for="password">
                Password
              </form-label>
            </form-group-left>
            <form-group-right>
              <form-input
                form="$ctrl.form"
                type="password"
                name="reasonPassword"
                required="true"
                errors="{ required: 'This is a required field.' }">
              </form-input>
            </form-group-right>
          </form-group-row>
          <hr>
          <p class="text-green-dark">
            Cancellation will take effect at the end of your next billing period
            - {{ $ctrl.subscription.nextBillingDate | date:'dd/MM/yyyy' }}.
          </p>
          <p>
            Your Voome subscription will remain active until the end of your
            <strong>current</strong> billing week. If you decide to reactivate
            your subscription at a later date, you'll have full access to all
            your content again.
          </p>
        </div>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileFieldsCancel.js